import { useMutation } from '@tanstack/react-query';
import axios from '../axios';

export type TRequestMagicLinkPayload = {
  email: string;
  redirectUrl: string;
  returnUrl?: string;
  returnApp?: string;
};

export type TRequestMagicLinkResponse = {
  success: boolean;
};

export const requestMagicLinkMutationFn = async (payload: TRequestMagicLinkPayload) => {
  const { data } = await axios.post<TRequestMagicLinkResponse>('/auth/request-magic-link', payload);
  return data;
};

export const useRequestMagicLinkMutation = () => {
  return useMutation({
    mutationFn: requestMagicLinkMutationFn,
    meta: {
      errorMessage: 'Could not send login link. Please try again shortly.',
    },
  });
};
